"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeSelectField = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_query_1 = require("react-query");
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const Api = __importStar(require("@src/api"));
const normalize_string_1 = require("@src/helpers/normalize-string");
const { Option } = elements_1.Select;
const SelectFieldWrapper = (props) => {
    const intl = (0, react_intl_1.useIntl)();
    const { offerTypes, useIdAsValue, value, onChange, defaultValue, ...otherProps } = props;
    const onSelectChange = (ids) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(ids.map(id => offerTypes.find(offerType => offerType.id === id)));
    };
    return ((0, jsx_runtime_1.jsx)(elements_1.Select, { mode: "multiple", placeholder: intl.formatMessage({ id: 'global.type.placeholder' }), showArrow: true, optionFilterProp: "children", value: useIdAsValue ? value : value === null || value === void 0 ? void 0 : value.map(offerType => offerType.id), defaultValue: useIdAsValue ? value : value === null || value === void 0 ? void 0 : value.map(offerType => offerType.id), onChange: useIdAsValue ? onChange : onSelectChange, showSearch: true, filterOption: (input, option) => (0, normalize_string_1.normalizeStr)(option.children).indexOf((0, normalize_string_1.normalizeStr)(input)) >= 0, ...otherProps, children: offerTypes.map(offerType => {
            // we need to pass string as children to option for using filterOption on Select search
            // if we pass <FormattedMessage.../> as children, search does not work
            const offerTypeName = intl.formatMessage({
                id: offerType.translation_key,
            });
            return ((0, jsx_runtime_1.jsx)(Option, { value: offerType.id, children: offerTypeName }, offerType.id));
        }) }));
};
const TypeSelectField = (props) => {
    const { rules, useIdAsValue = true, label, name, dependencies, ...otherProps } = props;
    const { data: offerTypes,
    // isLoading,
    // error,
     } = (0, react_query_1.useQuery)('filterTypes', async () => {
        const data = await Api.Offer.getOfferTypes();
        return data;
    });
    if (!offerTypes) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: label, name: name, rules: rules, dependencies: dependencies, children: (0, jsx_runtime_1.jsx)(SelectFieldWrapper, { useIdAsValue: useIdAsValue, offerTypes: offerTypes, ...otherProps }) }));
};
exports.TypeSelectField = TypeSelectField;
